import axios from 'axios';
import { GIFT_TABLE_ROOT, BASE_PATH_API } from 'constants/env';
import {
  giftsReceivedTransformer,
  orderDetailsTransformer,
} from './transformers';

export async function getGiftsReceived(giftTable, allOrders) {
  const url = `${BASE_PATH_API}/${GIFT_TABLE_ROOT}/gift-table/${giftTable}/orders?all_orders=${
    allOrders || 'false'
  }`;
  const res = await axios(url);
  const transformedGiftsReceived = giftsReceivedTransformer(
    res.data.data.orders
  );
  return {
    ...res.data.data,
    list: transformedGiftsReceived,
  };
}

export async function getGiftReceivedDetail(tableId, orderId) {
  const url = `${BASE_PATH_API}/${GIFT_TABLE_ROOT}/gift-table-order/${orderId}?gifttable_id=${tableId}`;
  const res = await axios({ url });
  const { data } = res.data;
  return {
    ...giftsReceivedTransformer([data])[0],
    gifts: orderDetailsTransformer(data.products),
  };
}
